export const apiRoutes = {
    login: 'auth/token',
    currentUser:'auth/user',
    upload:'uploads',
    customers: 'customers',
    customerGroups: 'customer-groups',
    users: 'users',
    teams: 'teams',
    team: 'team',
    updateTeams:'update-team',
    productCategories:'product-categories',
    products:'products',
    orders:'orders',
    generatePDF: 'generate-pdf',
    inventoryProducts: 'inventory',
    thermofisherProducts: 'thermofisher',
    roles: 'roles',
    permissions: 'permissions',
    templates: 'editor-template',
    templatesCategory: 'editor-template/categories'
}
